import { create } from "zustand";
import type { ProductOutput } from "../product/product.types";

export enum ConfiguratorTabs {
  PRODUCT_SPECIFICATION = "product_specification",
  TECHNICAL_DESIGN = "technical_design",
  DOWNLOADS = "downloads",
}

export enum TechnicalDesignInputModes {
  SINGLE_SELECTION = "single_selection",
  RESULT_LIST = "result_list",
}

export type ProjectUIStore = {
  activePartKey: string | null;
  setActivePartKey: (partKey: string | null) => void;
  activeTab: ConfiguratorTabs;
  setActiveTab: (tab: ConfiguratorTabs) => void;
  technicalDesignInputMode: TechnicalDesignInputModes;
  setTechnicalDesignInputMode: (mode: TechnicalDesignInputModes) => void;
};

const useProjectUIStore = create<ProjectUIStore>()((set, _get) => ({
  activePartKey: null,
  setActivePartKey: (partKey: string | null) => set({ activePartKey: partKey }),
  activeTab: ConfiguratorTabs.TECHNICAL_DESIGN,
  setActiveTab: (tab: ConfiguratorTabs) => set({ activeTab: tab }),
  technicalDesignInputMode: TechnicalDesignInputModes.RESULT_LIST,
  setTechnicalDesignInputMode: (mode: TechnicalDesignInputModes) =>
    set({ technicalDesignInputMode: mode }),
}));

export const useActivePartKey = () => useProjectUIStore((s) => s.activePartKey);
export const useSetActivePartKey = () =>
  useProjectUIStore((s) => s.setActivePartKey);

export const useActiveTab = () => useProjectUIStore((s) => s.activeTab);
export const useSetActiveTab = () => useProjectUIStore((s) => s.setActiveTab);

export const useTechnicalDesignInputMode = () =>
  useProjectUIStore((s) => s.technicalDesignInputMode);
export const useSetTechnicalDesignInputMode = () =>
  useProjectUIStore((s) => s.setTechnicalDesignInputMode);

export const syncTechnicalPropertiesActiveTab = (output: ProductOutput) => {
  // Currently, if the columnTitles are not available, we switch to the single selection mode. This is a temporary solution until we have a better way to handle this case.
  if (!output.product?.listViewConfiguration?.columnTitles) {
    useProjectUIStore.setState({
      technicalDesignInputMode: TechnicalDesignInputModes.SINGLE_SELECTION,
    });
  }
};

export const resetProductUIStore = () => {
  const initialState = useProjectUIStore.getInitialState();
  useProjectUIStore.setState(initialState);
};
